import React, { useContext, useEffect, useMemo, useState } from "react";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import AddTab from "../../../../Report/components/AddTab/AddTab";
import CustomEditor from "../../../../Report/components/CustomEditorSection/CustomEditor";
import AddTabVersion from "./AddTabVersion";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import NonEditableEditor from "./NonEditableEditor";
import { loadStudyReportVersionPdf } from "../../../../../service/StudyReportService";

const ViewReportModal = () => {
    const {showVersionModalForReport,setShowVersionModalForReport} = useContext(studylistContext);
    const [activeTabIndex,setActiveTabIndex] = useState(0);
    const [studyReportPdfSelected, setStudyReportPdfSelected] = useState(false);
    const [studyReportPdfUrl, setStudyReportPdfUrl] = useState("");

    const isVerticalMonitor = window.innerWidth <= 1200;
    const editorHeight = isVerticalMonitor
      ? Math.min(Math.max(window.innerHeight - 450, 200), 400)
      : Math.min(Math.max(window.innerHeight - 450, 250), 600);

    useEffect(() => {    
      if(showVersionModalForReport.studyReportPdfDto){
        loadStudyReportVersionPdf(showVersionModalForReport.studyReportPdfDto?.id).then(setStudyReportPdfUrl);
      }
    }, [showVersionModalForReport.studyReportPdfDto]);

    const modalDetails = {
        header: (
          <ModalHeader
            heading="Report"
            updatedModal = {true}
            handleCancel={() => setShowVersionModalForReport({show:false,data:[]})}
          />
        ),
        body: <>
        <div className="report-container" style={{display:'flex',flexDirection:'column',overflow:'auto',maxHeight:'calc(100vh - 130px)'}}>
            <div style={{borderBottom:"1px solid #4D4D4D", display:'flex',flexDirection:'column',flexShrink:0}}>
              <AddTabVersion data={showVersionModalForReport.data} 
                setActiveTabIndex={setActiveTabIndex} 
                activeTabIndex = {activeTabIndex} 
                studyReportPdfDto = {showVersionModalForReport.studyReportPdfDto} 
                studyReportPdfSelected = {studyReportPdfSelected}
                setStudyReportPdfSelected = {setStudyReportPdfSelected} />
            </div>
           <div style={{borderBottom:"1px solid #4D4D4D",paddingBottom:'5px',flexShrink:1,minHeight:0}}>
              <NonEditableEditor 
                  customHeight={editorHeight} 
                  data={showVersionModalForReport.data} 
                  activeTabIndex = {activeTabIndex} 
                  studyReportPdfSelected = {studyReportPdfSelected}
                  studyReportPdfUrl = {studyReportPdfUrl} />
           </div>
           </div>
        </>,
        footer: (
          <></>
        ),
        width: "735px",
        maxWidth: "calc(100vw - 40px)",
        maxHeight: "calc(100vh - 60px)"
      };

      const style=  {
        root:{
          backgroundColor: 'unset'
       },
        main:{
          boxSizing: "border-box",
          borderRadius: "10px 0px 0px 0px",
          fontFamily: "Open Sans",
          fontStyle: "normal",
          boxShadow: 'none',
          width:'726px'
        },
      }

    return (<>
    <ModalMain
        modalDetails={modalDetails}
        showModal={true}
        updatedModal = {true}
        //styles={style}
      />
    </>)
};

export default ViewReportModal;